'use client';
import React, { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { BaseTooltip } from '@/components';
import type { HarmonicSelection } from '../../types';

interface SideBandsPopoverProps {
  selections: HarmonicSelection[];
  onEnterSelectionMode: () => void;
  isSelectionMode?: boolean;
  disabled?: boolean;
  xAxisType?: 'date' | 'numeric' | 'category';
}

export const SideBandsPopover: React.FC<SideBandsPopoverProps> = ({
  isSelectionMode = false,
  disabled = false,
  onEnterSelectionMode,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      {/* Side Bands mode toggle button */}
      <BaseTooltip content="Add symmetrical lines around a center point - click center, then click offset to create mirrored lines">
        <Button
          ref={buttonRef}
          variant="ghost"
          size="sm"
          className={`gap-2 ${isSelectionMode ? 'bg-secondary text-primary-500 font-semibold' : 'text-[#55687d]'}`}
          disabled={disabled}
          onClick={() => {
            onEnterSelectionMode();
          }}
          style={isSelectionMode ? { cursor: 'crosshair' } : {}}
        >
          <Plus className="w-4 h-4" />
          Side Bands
        </Button>
      </BaseTooltip>

      {/* Global cursor change when in selection mode */}
      {isSelectionMode && (
        <style>{`
          body { cursor: crosshair !important; }
          * { cursor: crosshair !important; }
        `}</style>
      )}
    </>
  );
};
